import { Eq, eqStrict } from 'fp-ts/Eq';
import { pipe } from 'fp-ts/function';
import { uniq } from 'fp-ts/ReadonlyArray';
import * as C from 'io-ts/Codec';
import * as D from 'io-ts/Decoder';
import * as E from 'io-ts/Encoder';

export function UniqueArray<O, A>(
  item: C.Codec<unknown, O, A>,
  eq: Eq<A> = eqStrict,
): C.Codec<unknown, Array<O>, ReadonlyArray<A>> {
  const arrayUnique = uniq(eq);

  const decoder = pipe(
    D.array(item),
    D.parse((list) => D.success(arrayUnique(list))),
  );
  const encoder = pipe(
    { encode: arrayUnique },
    E.compose(E.readonly(E.array(item))),
  );

  return C.make<unknown, Array<O>, ReadonlyArray<A>>(decoder, encoder);
}
